import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { Section } from '../../../models';
import { InstallationTypeSectionIds, ChannelInstallationFieldIds } from './config-models';
import { field } from '../../../core/field-schema';
import { required, maxLength, pattern } from '../../../core/validator-builders';
import { ForesiteXDLocationCardState } from '../models';

export const getValidators = function (isMetric: boolean) {
    const validators = [required(), maxLength({ value: 100 })];

    if (isMetric) {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationMetricValuePattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR_METRIC',
            }),
        ];
    } else {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationValuePattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR',
            }),
        ];
    }
};

// Channel installation type configuration (Series 500)
export const channelInstallationConfig = (state: ForesiteXDLocationCardState): Section => {
    const settings = state.settings;
    const details = state.locationDetails && state.locationDetails.length > 0 ? state.locationDetails[0] : null;

    const FieldIds = ChannelInstallationFieldIds;
    return {
        info: {
            id: InstallationTypeSectionIds.Channel,
            title: '',
            displayTitle: false,
        },
        rows: [
            {
                info: {
                    id: 'channel-range-row',
                    panelClass: 'full-width',
                },
                items: [
                    field.number(FieldIds.Range, 'range', {
                        value: details ? details.range : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.HEIGHT',
                        placeholderSuffix: settings.depthUnit,
                        validators: getValidators(settings.isMetric),
                        panelClass: 'pad-t-6 full-width required',
                    }),
                ],
            },
        ],
    };
};
